import { QueryClient } from '@tanstack/react-query';

/**
 * Global react-query client
 *
 * Extracted to separate module to avoid circular dependencies.
 * Import anywhere e.g. in commands to fetch and invalidate queries
 * out of React components.
 */
export const queryClient = new QueryClient();
